import permissions from '../permissions'

const AI_INVENTORY_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.VISUALIZE,
    tag: permissions.AI_INVENTORY.SHOW,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.AI_INVENTORY.MANAGE,
  },
  {
    name: 'Gerenciar link externo',
    tag: permissions.AI_INVENTORY.MANAGE_GUEST_PORTAL,
    description:
      'Concede acesso à configuração do link externo (portal de visitantes) do Inventário de IA.',
  },
]

export default AI_INVENTORY_LIST
